<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  page: {
    title: "Delivery Unit External Office",
  },
  components: {
    Layout,
    PageHeader,
    Treeselect,
  },
  data() {
    return {
      title: "Delivery Unit External Office",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Delivery Unit External Office",
          active: true,
        },
      ],
      availableExternalOfficesConsist: "LEAF_PRIORITY",
      availableExternalOffices: [],
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      newData: [],
      fields: [
        {
          key: "item",
          sortable: true,
          label: "",
          thStyle: { width: "50px" },
        },
        {
          key: "campusName",
          sortable: true,
          label: `${this.GLOBAL_FROM_SCHOOL ? "Campus" : "Main Office"} Name`,
        },
        {
          key: "shortName",
          sortable: true,
          label: "Short Name",
        },
        {
          key: "location",
          sortable: true,
          label: "Location",
        },
      ],
      indexSelected: -1,
      tableBusy: false,
      selectedCampus: {},
      selectedOffice: {},
      selectedDU: null,

      // department
      department: {
        id: 0,
        departmentName: "",
        shortName: "",
        deliveryUnitId: 0,
      },
    };
  },
  validations: {
    department: {
      departmentName: { required },
    },
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  created() {
    this.totalRows = this.items.length;
    this.tableBusy = true;
    this.$store
      .dispatch("campus/GetCampusByAgency", this.$store.state.data.agency.id)
      .then((res) => {
        res.data.forEach((item) => {
          item.location = `${item.barangay}, ${item.city}, ${item.province}, ${item.region}, ${item.zipcode}`;
          item.rotateChevy = false;
          item.offices = [];
        });
        this.tableData = res.data;
        this.tableBusy = false;
      })
      .catch(() => {
        this.showToast("Something went wrong!", "error");
        this.tableBusy = false;
      });
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showDtls(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      row.toggleDetails();
      if (row.item.rotateChevy) {
        this.getOffices(row.item);
      }
    },
    getOffices(row) {
      this.$store
        .dispatch("office/GetOfficeByCampus", row.id)
        .then((res) => {
          res.data.forEach((item) => {
            item.showDtls = false;
            item.dus = [];
          });
          row.offices = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    getDUs(row) {
      row.showDtls = !row.showDtls;
      this.$store
        .dispatch("deliveryunit/GetDeliveryUnitByOffice", row.id)
        .then((res) => {
          res.data.forEach((item) => {
            item.showDtls = false;
            item.externalOffice = [];
          });
          row.dus = res.data;
          this.tableBusy = false;
        })
        .catch(() => {
          this.showToast("Fetching DU went wrong!", "error");
          this.tableBusy = false;
        });
    },
    getExternalOffice(row) {
      row.showDtls = !row.showDtls;
      this.$store
        .dispatch(
          "deliveryUnitExternalOffice/getDeliveryUnitExternalOfficeByDeliveryUnitId",
          row.id
        )
        .then((res) => {
          row.externalOffice = res.data;
          this.tableBusy = false;
        })
        .catch(() => {
          this.showToast("Fetching External Office Went Wrong!", "error");
          this.tableBusy = false;
        });
    },
    addAvailableExternalOffice(row) {
      this.selectedDU = row;
      this.availableExternalOffices = [];
      this.$store.commit(
        "deliveryUnitExternalOffice/setIsAvailableExternalOfficeLoading",
        true
      );
      this.$bvModal.show("available-modal");
      this.$store
        .dispatch(
          "deliveryUnitExternalOffice/getAvailableExternalOfficesByDUId",
          row.id
        )
        .then((response) => {
          this.availableExternalOffices = response.data.map((office) => ({
            id: office.officeId,
            label: office.officeName,
          }));
          this.$store.commit(
            "deliveryUnitExternalOffice/setIsAvailableExternalOfficeLoading",
            false
          );
        })
        .catch((error) => {
          this.$store.commit(
            "deliveryUnitExternalOffice/setIsAvailableExternalOfficeLoading",
            false
          );
          this.showToast(
            "Fetching Available External Office Went Wrong!",
            "error"
          );
        });
    },
    onCreateExternalOffice() {
      this.$bvModal.hide("available-modal");
      const payload = {
        deliveryUnitId: this.selectedDU.id,
        externalOfficeIds: this.newData,
      };
      this.$store
        .dispatch(
          "deliveryUnitExternalOffice/createDeliveryUnitExternalOffice",
          payload
        )
        .then((response) => {
          if (response.data.error) {
            this.showToast(response.data.error, "error");
            return;
          }
          this.$store
            .dispatch(
              "deliveryUnitExternalOffice/getDeliveryUnitExternalOfficeByDeliveryUnitId",
              this.selectedDU.id
            )
            .then((res) => {
              this.selectedDU.externalOffice = res.data;
            });
          this.showToast("Successfully created!", "success");
        })
        .catch((error) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    deleteExternalOffice(props, row) {
      let index = row.externalOffice.findIndex(
        (item) => item.officeId == props.officeId
      );

      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(
              "deliveryUnitExternalOffice/deleteDeliveryUnitExternalOfficeById",
              {
                deliveryUnitId: row.id,
                officeId: props.officeId,
              }
            )
            .then((res) => {
              if (res.status == 204) {
                row.externalOffice.splice(index, 1);
                this.showToast("Successfully deleted!", "success");
              } else {
                this.showToast("Something went wrong!", "error");
              }
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- Available external offices -->
    <b-modal
      id="available-modal"
      title="Add External offices"
      size="md"
      hide-footer
      no-close-on-backdrop
    >
      <div
        class="d-flex justify-content-center align-items-center"
        v-if="
          $store.state.deliveryUnitExternalOffice
            .isAvailableExternalOfficeLoading
        "
      >
        <div class="preloader-component me-2">
          <div class="status">
            <div class="spinner-chase w-20px h-20px">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <strong>Loading...</strong>
      </div>
      <div v-else>
        <treeselect
          :multiple="true"
          :options="availableExternalOffices"
          :value-consists-of="availableExternalOfficesConsist"
          :limit="5"
          :max-height="300"
          v-model="newData"
          :clearOnSelect="true"
        />
        <div class="modal-footer mb-0 pb-0">
          <b-button
            variant="info"
            @click="onCreateExternalOffice"
            v-if="newData.length > 0"
            >Save Changes</b-button
          >
          <b-button variant="link" @click="$bvModal.hide('available-modal')"
            >Close</b-button
          >
        </div>
      </div>
    </b-modal>
    <div class="row">
      <div class="col-12">
        <div class="card border">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="card-title m-0">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} List</h4>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      autocomplete="off"
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                :busy="tableBusy"
                @filtered="onFiltered"
                bordered
                outlined
                hover
                striped
                show-empty
              >
                <template #empty="scope">
                  <div class="text-center">
                    {{ scope.emptyText }}
                  </div>
                </template>
                <template #table-busy>
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-20px h-20px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template #cell(item)="row">
                  <div
                    class="d-flex align-items-center justify-content-center"
                    @click="showDtls(row)"
                  >
                    <!-- Display Offices -->
                    <i
                      class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
                      :class="{
                        'rotate-90': row.item.rotateChevy,
                      }"
                    ></i>
                  </div>
                </template>
                <template #row-details="row">
                  <div class="card">
                    <div
                      class="card-header d-flex align-items-center justify-content-between"
                    >
                      <h5 class="card-title mb-0">List of Offices</h5>
                    </div>
                    <div class="card-body px-3 py-2">
                      <div v-for="office in row.item.offices" :key="office.id">
                        <div class="d-flex align-items-center hover-toggle">
                          <div
                            class="font-size-15 cursor-pointer d-flex align-items-center text-info"
                            @click="getDUs(office)"
                          >
                            <i
                              class="bx bx-chevron-right me-1 rotate"
                              :class="{
                                'rotate-90': office.showDtls,
                              }"
                            ></i
                            >{{ office.name }}
                          </div>
                        </div>
                        <div v-if="office.showDtls">
                          <div
                            v-for="deliveryUnit in office.dus"
                            :key="`X${office.id}Y${deliveryUnit.id}`"
                            class="ms-3"
                          >
                            <div class="d-flex align-items-center hover-toggle">
                              <div
                                class="font-size-14 cursor-pointer d-flex align-items-center text-warning"
                                @click="getExternalOffice(deliveryUnit)"
                              >
                                <i
                                  class="bx bx-chevron-right me-1 rotate"
                                  :class="{
                                    'rotate-90': deliveryUnit.showDtls,
                                  }"
                                ></i
                                >({{ deliveryUnit.id }}) {{ deliveryUnit.name }}
                              </div>
                              <div class="zed-10 ms-1 hover-content">
                                <a
                                  href="javascript:void(0);"
                                  title="Add New External Office"
                                  @click="
                                    addAvailableExternalOffice(deliveryUnit)
                                  "
                                  ><i
                                    class="bx bxs-plus-square text-info font-size-18 align-middle"
                                  ></i
                                ></a>
                              </div>
                            </div>
                            <div v-if="deliveryUnit.showDtls">
                              <b-card class="my-2">
                                <b-card-text>
                                  <div class="d-flex justify-content-between">
                                    <div id="notice">
                                      <span
                                        v-if="
                                          deliveryUnit.externalOffice.length ===
                                          0
                                        "
                                      >
                                        This delivery unit has no external
                                        offices. Click the (+) sign button to
                                        add one.
                                      </span>
                                      <span v-else class="text-purple"
                                        >External Offices</span
                                      >
                                    </div>
                                    <div id="addButton">
                                      <a
                                        href="javascript:void(0);"
                                        title="Add New External Office"
                                        @click="
                                          addAvailableExternalOffice(
                                            deliveryUnit
                                          )
                                        "
                                        ><i
                                          class="bx bxs-plus-square text-info font-size-18 align-middle"
                                        ></i
                                      ></a>
                                    </div>
                                  </div>
                                  <div id="externalOfficeList">
                                    <div
                                      v-for="externalOffice in deliveryUnit.externalOffice"
                                      :key="`X${office.id}Y${deliveryUnit.id}Z${externalOffice.officeId}`"
                                      class="ms-4"
                                    >
                                      <div
                                        class="d-flex align-items-center hover-toggle"
                                      >
                                        <div
                                          class="font-size-12 d-flex align-items-center"
                                        >
                                          {{ externalOffice.officeName }}
                                        </div>
                                        <div class="zed-10 ms-1 hover-content">
                                          <a
                                            href="javascript:void(0);"
                                            title="Delete"
                                            @click="
                                              deleteExternalOffice(
                                                externalOffice,
                                                deliveryUnit
                                              )
                                            "
                                            ><i
                                              class="mdi mdi-trash-can text-danger"
                                            ></i
                                          ></a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </b-card-text>
                              </b-card>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.vue-treeselect__label {
  font-size: 16px !important;
  font-weight: 300;
  color: #fff;
}

.vue-treeselect__control {
  background-color: #2a3042;
}

.vue-treeselect__menu {
  background-color: #2a3042;
}

.vue-treeselect__option--highlight {
  background-color: #2a3042;
}

.vue-treeselect__input {
  color: #fff;
}
</style>
